document.addEventListener('DOMContentLoaded', function () {
    // 初期状態で company__group-map-link-accordion を非表示にする
    document.querySelectorAll('.company__group-map-link-accordion').forEach(function (accordion) {
        accordion.classList.add('-hidden');
        accordion.style.maxHeight = '0'; // アコーディオンの高さを0に設定
        accordion.style.overflow = 'hidden'; // 非表示時に内容を隠す
    });

    // -accordion を持つ company__group-map-link-block のクリックイベントを設定
    document.querySelectorAll('.company__group-map-link-block.-accordion').forEach(function (block) {
        block.addEventListener('click', function (event) {
            const accordion = block.querySelector('.company__group-map-link-accordion');
            if (accordion) {
                const isHidden = accordion.classList.contains('-hidden');

                // 現在のアコーディオンの表示/非表示を切り替え
                if (isHidden) {
                    accordion.classList.remove('-hidden');
                    if (window.innerWidth <= 1020) {
                        // 1020px以下の場合、アニメーションを適用
                        accordion.style.transition = 'max-height 0.3s ease';
                        accordion.style.maxHeight = accordion.scrollHeight + 'px'; // アコーディオンの高さを設定
                    } else {
                        // 1021px以上の場合、即時に表示
                        accordion.style.transition = ''; // アニメーションを無効化
                        accordion.style.maxHeight = 'none';
                    }
                    block.classList.add('-opened');
                } else {
                    accordion.classList.add('-hidden');
                    if (window.innerWidth <= 1020) {
                        // 1020px以下の場合、アニメーションを適用
                        accordion.style.transition = 'max-height 0.3s ease';
                        accordion.style.maxHeight = '0'; // 高さを0に戻す
                    } else {
                        // 1021px以上の場合、即時に非表示
                        accordion.style.transition = ''; // アニメーションを無効化
                        accordion.style.maxHeight = '0';
                    }
                    block.classList.remove('-opened');
                }

                // 1021px以上の場合、他のアコーディオンを閉じる
                if (window.innerWidth >= 1021) {
                    document.querySelectorAll('.company__group-map-link-block.-accordion.-opened').forEach(function (otherBlock) {
                        if (otherBlock !== block) {
                            const otherAccordion = otherBlock.querySelector('.company__group-map-link-accordion');
                            if (otherAccordion) {
                                otherAccordion.classList.add('-hidden');
                                otherAccordion.style.maxHeight = '0';
                                otherBlock.classList.remove('-opened');
                            }
                        }
                    });
                }
            }

            // 他のクリックイベントを止める（親要素クリック時に閉じる処理と競合しないように）
            event.stopPropagation();
        });
    });

    // company__group-map-link-accordion 内の a 要素をクリックしたときはアコーディオンを閉じない
    document.querySelectorAll('.company__group-map-link-accordion a').forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    });

    // 画面幅に応じたクリックイベント
    if (window.innerWidth >= 1021) {
        // 1021px以上の場合、親要素がクリックされた際にすべてのアコーディオンを閉じる
        document.addEventListener('click', function () {
            document.querySelectorAll('.company__group-map-link-block.-accordion.-opened').forEach(function (block) {
                const accordion = block.querySelector('.company__group-map-link-accordion');
                if (accordion) {
                    accordion.classList.add('-hidden');
                    accordion.style.maxHeight = '0';
                    block.classList.remove('-opened');
                }
            });
        });
    } else {
        // 1020px以下の場合は何もしない
        document.addEventListener('click', function () {
            // この場合、クリックイベントは特に何も実行しません
        });
    }
});
